var React = require('react');

function IconBack (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M7.175 0L8.59 1.415l-4.76 4.76H21.63v2H3.828l4.761 4.761-1.414 1.414-5.76-5.761L0 7.175l1.414-1.414L7.175 0z"}));
}

IconBack.defaultProps = {"width":"22","height":"15","viewBox":"0 0 22 15"};

module.exports = IconBack;

IconBack.default = IconBack;
